import { defineMessages } from "react-intl"

export const messages = defineMessages({
    paymentPresenting: {
        id: "rainforest-terminal-payment.payment-presenting",
        defaultMessage: "Present the terminal to the customer to capture the credit card payment",
    },
    paymentSuccess: {
        id: "rainforest-terminal-payment.payment-success",
        defaultMessage: "A payment has been successfully captured. You will be redirected automatically once it is processing.",
    },
    paymentFailed: {
        id: "rainforest-terminal-payment.payment-failed",
        defaultMessage: "The payment failed with the following error: {declinedReason} Do you want to try again?",
    },
    paymentCancelled: {
        id: "rainforest-terminal-payment.payment-cancelled",
        defaultMessage: "The payment was cancelled by the client.",
    },
    paymentError: {
        id: "rainforest-terminal-payment.payment-error",
        defaultMessage: "There was an error with the transaction. Ensure that the device is connected and available before trying again.",
    },
    cancel: {
        id: "rainforest-terminal-payment.cancel",
        defaultMessage: "Cancel",
    },
    retry: {
        id: "rainforest-terminal-payment.retry",
        defaultMessage: "Retry",
    },
    pay: {
        id: "rainforest-terminal-payment.pay",
        defaultMessage: "Pay",
    },
    saveCard: {
        id: "rainforest-terminal-payment.save_card_checkbox",
        defaultMessage: "Save card for future payments",
    }
})


// WEBPACK FOOTER //
// ./src/common/terminal-payment/rainforest/messages.ts